import React from 'react';
import PropTypes from 'prop-types';
import RehypeReact from 'rehype-react';
import MediaQueries from 'react-responsive';

import Spacing from '@marvelapp/marvel-ui/spacing';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';

import markdownComponents from 'marketing-website/components/markdown';
import Page from 'marketing-website/components/modules/Page';
import Sidebar from 'marketing-website/components/modules/Sidebar';
import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck.js';
import metaData from 'marketing-website/data/metadata.js';

import styles from './style/docs.css';

import './style/code.css';

export default function ApiDocDetailTemplate({ data }) {
  if (!data || !data.markdownRemark) return null;

  const { markdownRemark } = data;
  const { frontmatter, htmlAst } = markdownRemark;
  const { page } = frontmatter;

  const renderAst = new RehypeReact({
    createElement: React.createElement,
    components: markdownComponents,
  }).Compiler;

  const { developers } = metaData;
  const pageProps = {
    title: `${developers[page].title}`,
    meta: getMetaTags(developers[page].description, developers[page].keywords),
    header: {
      type: 'developer',
    },
    footer: false,
  };

  return (
    <Page {...pageProps}>
      <PageWrap maxWidth={1016}>
        <div className={styles.page}>
          <div className={styles.leftColumn}>
            <MediaQueries minWidth={770}>
              <Sidebar />
            </MediaQueries>
          </div>

          <MediaQueries minWidth={770}>
            <div className={styles.rightColumn}>{renderAst(htmlAst)}</div>
          </MediaQueries>

          <MediaQueries maxWidth={770}>
            <Spacing type="padding" position="top" size="m">
              {renderAst(htmlAst)}
            </Spacing>
          </MediaQueries>
        </div>
      </PageWrap>
    </Page>
  );
}

ApiDocDetailTemplate.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      htmlAst: PropTypes.object,
      frontmatter: PropTypes.shape({
        page: propTypeEmptyString,
        summary: propTypeEmptyString,
      }),
    }),
  }),
};

export const apiDocQuery = graphql`
  query ApiDocByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      htmlAst
      frontmatter {
        page
        path
      }
    }
  }
`;

function getMetaTags(description, keywords) {
  const meta = [];
  if (description) {
    meta.push({ name: 'description', content: description });
  }
  if (keywords) {
    meta.push({ name: 'keywords', content: keywords });
  }
  return meta;
}



// WEBPACK FOOTER //
// ./src/templates/apiDocs.js